import React, { useContext, useState } from 'react';
import { string, func } from 'prop-types';
import { Dropdown, Menu } from 'antd';
import { i18nContext } from 'context/i18n';
import { ChevronSVG } from 'components/iconsSVG/chevron';
import styles from './style.module.css';

const availableSorts = [
  {
    value: 0,
    label: 'de.mayor.menor.calificacion',
    default: 'Highest to Lowest Rating',
  },
  {
    value: 1,
    label: 'de.menor.mayor.calificación',
    default: 'Lowest to Highest Rating',
  },
  {
    value: 2,
    label: 'mas.antiguos',
    default: 'Oldest',
  },
  {
    value: 3,
    label: 'mas.recientes',
    default: 'Most Recent',
  },
];

// puesto que value es un int, lo usamos como índice para la array de mapeo
const sortTypeMap = [
  ['rating', 'desc'],
  ['rating', 'asc'],
  ['SubmissionTime', 'asc'],
  ['SubmissionTime', 'desc'],
];

function SortReviews({ label = 'ordenar.por', onClick = () => {} }) {
  const { t } = useContext(i18nContext);
  const [activeSort, setActiveSort] = useState(0);
  // const [ activeTab, setActiveTab ] = useState('1');
  const handleClickSort = (value) => {
    setActiveSort(value);
    onClick(sortTypeMap[value]);
  };
  return (
    <Dropdown
      overlayClassName={styles.popoverCustom}
      overlayStyle={{
        minWidth: '0px',
      }}
      placement="bottomLeft"
      trigger={['hover']}
      overlay={
        <Menu className={styles.customMenu}>
          {availableSorts.map((sort) => (
            <Menu.Item key={sort.value} className={sort.value === activeSort ? styles.selectedItem : ''} onClick={() => handleClickSort(sort.value)}>
              {t('ficha.producto', sort.label, sort.default)}
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <span>
        {`${t('menu.lateral', label)} : ${t('ficha.producto', availableSorts.filter((sort) => sort.value === activeSort)[0].label)}`}
        <span className={styles.caretSpan}>
          <ChevronSVG width={11} />
        </span>
      </span>
    </Dropdown>
  );
}

SortReviews.propTypes = {
  label: string,
  onClick: func,
};

export default SortReviews;
